import { MutationTree } from 'vuex'
import State, { IUser, IUserSearchFilter } from './types'
import { blankSearchFilters, blankUser, blankUserArray } from './constants'
import { ResponseArray } from '../types'

export const mutations: MutationTree<State> = {
  userLoading(state: State) {
    state.loading = true
    state.error = false
    state.userList = blankUserArray
  },
  userLoaded(state: State, User: IUser) {
    state.error = false
    state.activeUser = User
    state.loading = false
  },
  userError(state, errorMessage: string) {
    state.error = true
    state.errorMessage = errorMessage
    state.activeUser = blankUser
    state.loading = false
  },
  usersLoading(state: State) {
    state.error = false
    state.userList = blankUserArray
  },
  usersLoaded(state: State, Users: ResponseArray<IUser>) {
    state.error = false
    state.userList = Users
  },
  usersError(state) {
    state.error = true
    state.userList = blankUserArray
  },
  userFilterUpdated(state: State, filter: IUserSearchFilter) {
    state.searchFilters = { ...state.searchFilters, ...filter }
  },
  userFilterError(state: State) {
    state.searchFilters = { ...state.searchFilters, ...blankSearchFilters }
  },
}
